/*
* Dependencies
*/
var $ = require('jquery');
var _ = require('lodash');
var AriesComponent = require('./aries-component');
var PubSub = require('./pub-sub');
var Loader = require('./lazy-load');
/*
* Main class
*/
var componentLoader = AriesComponent.extend({
  //optionally specify where to resolve the widget component
  renderType: 'server',

  subscribe: {
    'WIDGET_REFRESH': 'refreshWidget',
    'WIDGET_CLOSE': 'closeWidget'
  },

  /*
   * Spinner handle
   */
  spinner: {
    start: function(layout) {
      layout.append('<div class="progress widget-loader"><div>Loading...</div></div>');
    },
    stop: function(layout) {
      layout.find('.progress').remove();
    }
  },
  ajaxRequest: null,
  /*
  * Class constructor
  */
  initialize: function(props) {
    //set widget specific properties
    this.props = props;
    if (!_.isUndefined(this.props.renderType))
      this.renderType = this.props.renderType;
    if (!_.isUndefined(this.props.url))
      this.url = this.props.url;
    if (!_.isUndefined(this.props.data.context))
      this.context = this.props.data.context;
    if (!_.isUndefined(this.props.data.sessionToken))
      this.sessionToken = this.props.data.sessionToken;
    if (!_.isUndefined(this.props.data.sourceURI))
      this.sourceURI = this.props.data.sourceURI;

    //asynchronously load widget
    this.ajaxRequest = this._loadComponent();
    //subscribe pub sub messages
    this.subscribePubSubMessages();
    //subscribe DOM Events
    this.subscribeDOMEvents();
    //start spinner when loading starts
    if (!this.props.hideSpinner) {
      this.spinner.start(this.props.layout);  
    }
    
  },
  abort: function(){
    this.ajaxRequest.abort();
    if(this.$el != null) this.closeWidget();
  },
  refreshWidget: function(data, onCompleteCallback) {
    this.closeWidget();
    if (!this.props.hideSpinner) {
      this.spinner.start(this.props.layout);  
    }
    this._loadComponent(data).complete(onCompleteCallback);
  },

  closeWidget: function() {
    this.$el.off();
    this.$el.remove();
  },

  /*
   * Loads widget
   */
  _loadComponent: function(defs) {
    //set data for the ajax call
    var url = this.url,
    dataType = (this.renderType === 'server') ? 'html' : 'json',
    data = ((_.isUndefined(defs)) ? this.props.data : defs),
    method = (this.renderType === 'server') ? 'GET' : 'POST',
    _self = this;
    var loader = new Loader();

    return this.makeAjaxCall({
      method: method,
      url: url,
      data: data,
      dataType: dataType,
      contentType: 'text/html',
      success: _.bind(function(response) {
        var html = $(response);
        loader.loadDependencies(html);

        this.$el = this.props.sourceBlock ? html.find(this.props.sourceBlock) : html.find('[data-component-id], .pci-data-frame-container');
        if (!this.props.hideSpinner) {
          this.spinner.stop(this.props.layout);
        }
        this.props.layout.append(this.$el);
        if(typeof this.props.success === 'function'){
          this.props.success(this.props.layout);
        }
      }, this),
      error: _.bind(function(response) {
        if(typeof this.props.error === 'function') {
          this.props.error();
        }
      }, this)
    });
  }
});
module.exports = componentLoader;
